import { render, staticRenderFns } from "./OrderOptionGroup.vue?vue&type=template&id=4b07bc58"
import script from "./OrderOptionGroup.vue?vue&type=script&lang=ts"
export * from "./OrderOptionGroup.vue?vue&type=script&lang=ts"
import style0 from "./OrderOptionGroup.vue?vue&type=style&index=0&id=4b07bc58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports